import { render, staticRenderFns } from "./coachWriting.vue?vue&type=template&id=519e554e&scoped=true&"
import script from "./coachWriting.vue?vue&type=script&lang=js&"
export * from "./coachWriting.vue?vue&type=script&lang=js&"
import style0 from "./coachWriting.vue?vue&type=style&index=0&id=519e554e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519e554e",
  null
  
)

export default component.exports